// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/restaurant-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 64px);
  background: linear-gradient(rgba(1, 16, 41, 0.3), rgba(1, 16, 41, 0.4)),
              url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  padding: 20px;
}

.login-box {
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  border-radius: 8px;
  padding: 2.5em;
  width: fit-content;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.login-box h2 {
  color: white;
  text-align: center;
  margin-bottom: 1.5rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.5em;
  min-width: 300px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.form-label {
  color: white;
  font-size: 0.9em;
  font-weight: 500;
}

.form-input {
  padding: 0.75em;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  background-color: #2D2D2D;
  color: #FFFFFF;
  font-size: 1em;
}

.form-input:focus {
  outline: none;
  border-color: #BB86FC;
  box-shadow: 0 0 0 2px rgba(187, 134, 252, 0.2);
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-container .form-input {
  width: 100%;
  padding-right: 40px; /* Make room for the eye icon */
}

.password-toggle-btn {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.password-toggle-btn:hover {
  color: rgba(255, 255, 255, 0.9);
}

.password-toggle-btn svg {
  width: 16px;
  height: 16px;
}

.login-button {
  background-color: #2175f37e;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  height: 36px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 0.5em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.login-button:hover {
  background-color: #1976D2;
}

.login-button:disabled {
  background-color: rgba(33, 150, 243, 0.5);
  cursor: not-allowed;
}

/* Placeholder text color */
.form-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.login-box .form-group label,
.login-form .form-group label {
  color: #FFFFFF !important;
}

.error-message {
  background-color: rgba(255, 82, 82, 0.1);
  color: #FF5252;
  padding: 1em;
  border-radius: 4px;
  margin-bottom: 1em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B;qDACwD;EACxD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: calc(100vh - 64px);\n  background: linear-gradient(rgba(1, 16, 41, 0.3), rgba(1, 16, 41, 0.4)),\n              url('../../assets/images/restaurant-bg.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  color: white;\n  padding: 20px;\n}\n\n.login-box {\n  background-color: rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(8px);\n  border-radius: 8px;\n  padding: 2.5em;\n  width: fit-content;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.login-box h2 {\n  color: white;\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5em;\n  min-width: 300px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n}\n\n.form-label {\n  color: white;\n  font-size: 0.9em;\n  font-weight: 500;\n}\n\n.form-input {\n  padding: 0.75em;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  background-color: #2D2D2D;\n  color: #FFFFFF;\n  font-size: 1em;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #BB86FC;\n  box-shadow: 0 0 0 2px rgba(187, 134, 252, 0.2);\n}\n\n.password-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-container .form-input {\n  width: 100%;\n  padding-right: 40px; /* Make room for the eye icon */\n}\n\n.password-toggle-btn {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.7);\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.password-toggle-btn:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.password-toggle-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.login-button {\n  background-color: #2175f37e;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  height: 36px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  margin-top: 0.5em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.login-button:hover {\n  background-color: #1976D2;\n}\n\n.login-button:disabled {\n  background-color: rgba(33, 150, 243, 0.5);\n  cursor: not-allowed;\n}\n\n/* Placeholder text color */\n.form-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.login-box .form-group label,\n.login-form .form-group label {\n  color: #FFFFFF !important;\n}\n\n.error-message {\n  background-color: rgba(255, 82, 82, 0.1);\n  color: #FF5252;\n  padding: 1em;\n  border-radius: 4px;\n  margin-bottom: 1em;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
